const mixinUser = {
  computed: {
    logged () {
      return this.$store.getters.logged
    }
  }
}

export default mixinUser



// WEBPACK FOOTER //
// ./src/pages/index/mixins/user.js